import { IoNotificationsOutline } from "react-icons/io5";

export type NotificationBadgeProps = {
  count: number;
  size?: number;
};

/** The actual component */
export const NotificationBadge = ({
  count,
  size = 24,
}: NotificationBadgeProps): React.ReactElement => (
  <div
    style={{
      position: "relative",
      display: "inline-block",
      width: size,
      height: size,
    }}
  >
    <IoNotificationsOutline size={size} />

    {count > 0 && (
      <span
        style={{
          position: "absolute",
          top: -2,
          left: -3,
          background: "red",
          color: "white",
          borderRadius: "50%",
          width: size / 2.3,
          height: size / 2.3,
          pointerEvents: "none",
        }}
        aria-hidden="true"
      />
    )}
  </div>
);

export default NotificationBadge;
